export default "__VITE_ASSET__9dbfd518__"